// Credential HTTP payloads must never enter session replay network capture.
export function maskPublishingCredentialRequest(request) {
    return /managepublishingcredentials/i.test(request.name || request.url || '') ? null : request;
}
